import classNames from 'classnames';
import { t } from '@bg-shared';
import classes from './ExternalGameStatus.module.scss';

interface IProps {
    showLoginMessage?: boolean;
}

export const ExternalGameStatus = (props: IProps) => (
    <div className={classNames(classes.container, { [classes.message]: props.showLoginMessage })}>
        {props.showLoginMessage && t.string('please_login')}
    </div>
);
